import type { ReactNode } from 'react'
import { NotificationsContext } from './notificationsContext'
import { useNotifications } from './useNotifications'

/**
 * Owns the single `useNotifications` instance for a page.
 *
 * The responsive workspace shell mounts a bell in the desktop aside *and* in
 * the mobile topbar — CSS hides one, but React mounts both. Without this
 * provider each bell ran its own initial fetch and its own realtime
 * subscription, so every desktop page did the work twice and every realtime
 * event triggered two refetches. Here the data is fetched once and both bells
 * read it; their `open`/`activeGroup` UI state stays per-instance.
 */
export function NotificationsProvider({
  recipientId,
  children,
}: {
  recipientId: string | null
  children: ReactNode
}) {
  const value = useNotifications(recipientId)
  return <NotificationsContext.Provider value={value}>{children}</NotificationsContext.Provider>
}
